import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgCheckboxUnchecked = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("rect", {
    width: 15,
    height: 15,
    x: 4.5,
    y: 4.5,
    fill: "#fff",
    stroke: "#847F7B",
    rx: 3.5
  })
});
export default SvgCheckboxUnchecked;